import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { httpClient } from '../utils/fetch-client';
import { authBaseURL } from '../utils/environment';

const MFA_SMS_URL = `${authBaseURL}/v1/mfas/sms`;

function postOtpSms(): Promise<unknown> {
  return httpClient.post(MFA_SMS_URL, {
    body: { otp: {} },
    credentials: 'include',
  });
}

export function useOtpSms(): UseMutationResult<unknown, unknown, void> {
  return useMutation({
    mutationFn: () => postOtpSms(),
  });
}

function postActivateSms({ otpToken }: { otpToken: string }): Promise<unknown> {
  return httpClient.post(`${MFA_SMS_URL}/activate`, {
    body: { otp: { token: otpToken } },
    credentials: 'include',
  });
}

export function useActivateSms(): UseMutationResult<unknown, unknown, { otpToken: string }> {
  return useMutation({
    mutationFn: ({ otpToken }: { otpToken: string }) => postActivateSms({ otpToken }),
  });
}

function postTriggerSms(): Promise<unknown> {
  return httpClient.post(`${MFA_SMS_URL}/trigger`, {
    body: { otp: { context: 'action' } },
    credentials: 'include',
  });
}

export function useTriggerSms(): UseMutationResult<unknown, unknown, undefined> {
  return useMutation({
    mutationFn: () => postTriggerSms(),
  });
}
